// Anonymized employer testimonials from Ignite Health.
// Use in <StoryCards /> to render trust-building story cards.

export const STORIES = [
    {
        id: "healthcare-network",
        quote:
            "Since launching the Ignite Plan, we've seen a major reduction in staff burnout and absenteeism. Monthly mental health sessions and on-site wellness initiatives have improved morale, lowered insurance costs, and made a tangible difference in retention.",
        role: "HR Director",
        org: "National Healthcare Network",
        tag: "Healthcare",
    },
    {
        id: "charter-school",
        quote:
            "Introducing preventative care practices helped us tackle rising healthcare costs and staff stress head-on. Wellness fairs, screenings, and mental health consults not only boosted teacher satisfaction, they also saved us thousands in annual premiums.",
        role: "Superintendent",
        org: "Public Charter School",
        tag: "Education",
    },
    {
        id: "freight",
        quote:
            "For a workforce constantly on the road, providing easy access to preventative care was essential. Telemedicine and wellness incentives significantly reduced turnover and improved overall engagement, while helping us cut down on costly claims.",
        role: "Operations Manager",
        org: "National Freight Company",
        tag: "Transportation & Logistics",
    },
    {
        id: "construction",
        quote:
            "We were facing serious challenges with workplace injuries and chronic conditions. Implementing the Ignite Plan helped lower safety incidents and workers' comp claims. Just as importantly, our team feels more supported and engaged.",
        role: "Safety Supervisor",
        org: "Regional Construction Firm",
        tag: "Construction",
    },
    {
        id: "financial-advisory",
        quote:
            "The Ignite Plan brought mental wellness to the forefront. Regular workshops and health screenings made a measurable impact — engagement improved, absenteeism dropped, and we saw real savings in our health claims.",
        role: "Director of Talent",
        org: "Financial Advisory Firm",
        tag: "Financial Services",
    },
    {
        id: "grocery",
        quote:
            "With turnover at an all-time high, we knew we needed to invest in employee health. The Ignite Plan's initiatives, like wellness fairs and walking challenges, helped us build a stronger culture and significantly reduced our insurance expenses.",
        role: "Store Manager",
        org: "Grocery Chain",
        tag: "Retail Grocery",
    },
    {
        id: "hotel",
        quote:
            "Hotel staff health is often overlooked, but with the Ignite Plan, we saw clear improvements in retention, energy levels, and workplace morale. Healthier staff means better service and lower healthcare costs.",
        role: "VP of Operations",
        org: "Boutique Hotel Group",
        tag: "Hospitality",
    },
    {
        id: "manufacturing",
        quote:
            "The Ignite Plan helped us address the root causes of rising healthcare costs — things like chronic conditions and workplace stress. Our employees now feel more in control of their health, and the financial benefits have been impressive.",
        role: "Director of HR",
        org: "Precision Manufacturing Company",
        tag: "Manufacturing",
    },
    {
        id: "software",
        quote:
            "In our fast-paced environment, burnout was becoming the norm. The Ignite Plan, especially the virtual tools and team wellness challenges, helped bring balance back to the workplace. Productivity and collaboration have never been better.",
        role: "People & Culture Lead",
        org: "Software Company",
        tag: "Technology",
    },
    {
        id: "city-government",
        quote:
            "Our city employees needed more than just traditional benefits — they needed meaningful, preventative support. With regular screenings and mental health services in place, we've seen stronger morale and a significant drop in overall healthcare spending.",
        role: "Wellness Program Coordinator",
        org: "City Government",
        tag: "Public Sector",
    },
];
